import { GetterTree } from "vuex";
import { CommonState, RootState } from "@/types/common";

const getters: GetterTree<CommonState, RootState> = {
  isLoading: (state: CommonState) => {
    return state.isLoading;
  },
  getApiBaseParams: (state: CommonState) => {
    return state.apiBaseParams;
  },
  getApiError: (state: CommonState) => {
    return state.apiError;
  },
  getLogId: (state: CommonState) => {
    return state.logId;
  },
  getSearchAppliance: (state: CommonState) => {
    return state.searchAppliance;
  },
  getAttachmentList: (state: CommonState) => {
    return state.attachmentList;
  },
  getFullscreenLoadingState: (state: CommonState) => {
    return state.isFullscreenLoading;
  },
  getPantryCameraImage: (state: CommonState) => {
    return state.pantryCameraImage;
  }
};

export default getters;
